var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fab-transition',[_c('sButton',{directives:[{name:"show",rawName:"v-show",value:(_vm.up_btn),expression:"up_btn"}],staticClass:"up-btn",attrs:{"icon":"long-arrow","icon-class":"s-svg-icon-rotate-180","icon-size":"12px","type":"green"},on:{"click":_vm.click}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }